import { create } from 'zustand';

interface Reward {
  currency: string;
  amount: number;
}
interface BluePageState {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  setTitle: (title: string) => void;
  description: string;
  setDescription: (description: string) => void;
  rewards: Reward[];
  setRewards: (rewards: Reward[]) => void;
  onClose: () => void;
  setOnClose: (onClose: () => void) => void;
  onClaimOnBoxModal: () => void;
  setOnClaimOnBoxModal: (onClaimOnBoxModal: () => void) => void;
}

export const useBluePageStore = create<BluePageState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  title: '',
  setTitle: (title) => set({ title }),
  description: '',
  setDescription: (description) => set({ description }),
  rewards: [],
  setRewards: (rewards) => set({ rewards }),
  onClose: () => set({ open: false }),
  setOnClose: (onClose) => set({ onClose }),
  onClaimOnBoxModal: () => set({ open: false }),
  setOnClaimOnBoxModal: (onClaimOnBoxModal) => set({ onClaimOnBoxModal }),
}));
